(function () {
  'use strict';

  var config = window.fullordLocalization || {};

  var currentCountry = String(
    config.currentCountry ||
    (window.Shopify && window.Shopify.country) ||
    ''
  ).toUpperCase();

  var availableCountries = Array.isArray(config.availableCountries)
    ? config.availableCountries.map(function (countryCode) {
        return String(countryCode).toUpperCase();
      })
    : [];

  var formId = config.formId || 'FullordAutoLocalization';
  var stateKey = 'fullord-market-switch-state-v2';
  var stateCookie = 'fullord_market_switch_state_v2';
  var maximumAttempts = 2;
  var stateLifetime = 2 * 60 * 1000;

  if (!currentCountry || availableCountries.length === 0) {
    return;
  }

  function getRootUrl() {
    var rootUrl =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    if (rootUrl.charAt(0) !== '/') {
      rootUrl = '/' + rootUrl;
    }

    if (rootUrl.charAt(rootUrl.length - 1) !== '/') {
      rootUrl += '/';
    }

    return rootUrl;
  }

  function readCookie(name) {
    var cookiePrefix = name + '=';
    var cookies = document.cookie ? document.cookie.split(';') : [];

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf(cookiePrefix) === 0) {
        try {
          return decodeURIComponent(cookie.substring(cookiePrefix.length));
        } catch (error) {
          return '';
        }
      }
    }

    return '';
  }

  function writeCookie(name, value, maxAge) {
    try {
      document.cookie =
        name +
        '=' +
        encodeURIComponent(value) +
        '; path=/; max-age=' +
        maxAge +
        '; SameSite=Lax';
    } catch (error) {
      // Cookie access might be unavailable.
    }
  }

  function removeCookie(name) {
    writeCookie(name, '', 0);
  }

  function getSwitchState() {
    var rawState = '';

    try {
      rawState = window.sessionStorage.getItem(stateKey) || '';
    } catch (error) {
      rawState = readCookie(stateCookie);
    }

    if (!rawState) {
      rawState = readCookie(stateCookie);
    }

    if (!rawState) {
      return null;
    }

    try {
      var state = JSON.parse(rawState);

      if (
        !state ||
        !state.targetCountry ||
        !state.createdAt ||
        Date.now() - state.createdAt > stateLifetime
      ) {
        clearSwitchState();
        return null;
      }

      return state;
    } catch (error) {
      clearSwitchState();
      return null;
    }
  }

  function saveSwitchState(state) {
    var serializedState = JSON.stringify(state);

    try {
      window.sessionStorage.setItem(stateKey, serializedState);
    } catch (error) {
      // Cookie fallback is written below.
    }

    writeCookie(
      stateCookie,
      serializedState,
      Math.ceil(stateLifetime / 1000)
    );
  }

  function clearSwitchState() {
    try {
      window.sessionStorage.removeItem(stateKey);
    } catch (error) {
      // Ignore storage errors.
    }

    removeCookie(stateCookie);
  }

  function getCleanReturnPath() {
    var url = new URL(window.location.href);
    var rootUrl = getRootUrl();
    var pathname = url.pathname;

    /*
     * Remove the current market/language prefix.
     *
     * Example:
     * /en-us/products/example → /products/example
     *
     * Shopify can then apply the URL prefix belonging to the new Market.
     */
    if (rootUrl !== '/') {
      var rootWithoutTrailingSlash = rootUrl.replace(/\/$/, '');

      if (
        pathname === rootWithoutTrailingSlash ||
        pathname.indexOf(rootWithoutTrailingSlash + '/') === 0
      ) {
        pathname = pathname.substring(rootWithoutTrailingSlash.length);

        if (!pathname) {
          pathname = '/';
        }
      }
    }

    /*
     * An existing country parameter can override the newly submitted
     * localization and switch the visitor back to the old country.
     */
    url.searchParams.delete('country');
    url.searchParams.delete('country_code');

    return pathname + url.search + url.hash;
  }

  function getLocalizationForm() {
    var form = document.getElementById(formId);

    if (!form) {
      return null;
    }

    var countryInput = form.querySelector('[name="country_code"]');
    var returnInput = form.querySelector('[name="return_to"]');

    if (!countryInput) {
      return null;
    }

    return {
      form: form,
      countryInput: countryInput,
      returnInput: returnInput
    };
  }

  function canAttemptSwitch(targetCountry) {
    var state = getSwitchState();

    if (!state || state.targetCountry !== targetCountry) {
      return true;
    }

    return Number(state.attempts || 0) < maximumAttempts;
  }

  function recordSwitchAttempt(targetCountry) {
    var previousState = getSwitchState();
    var attempts = 1;

    if (
      previousState &&
      previousState.targetCountry === targetCountry
    ) {
      attempts = Number(previousState.attempts || 0) + 1;
    }

    saveSwitchState({
      sourceCountry: currentCountry,
      targetCountry: targetCountry,
      attempts: attempts,
      createdAt: Date.now()
    });
  }

  function switchCountry(targetCountry) {
    var localization = getLocalizationForm();

    if (!localization || !canAttemptSwitch(targetCountry)) {
      return false;
    }

    localization.countryInput.value = targetCountry;

    if (localization.returnInput) {
      localization.returnInput.value = getCleanReturnPath();
    }

    recordSwitchAttempt(targetCountry);

    /*
     * Use the native submit method so unrelated submit handlers and apps
     * cannot cancel Shopify's localization request.
     */
    HTMLFormElement.prototype.submit.call(localization.form);

    return true;
  }

  async function detectCountry() {
    var rootUrl = getRootUrl();

    var suggestionUrl =
      rootUrl +
      'browsing_context_suggestions.json' +
      '?country[enabled]=true' +
      '&country[exclude]=' +
      encodeURIComponent(currentCountry) +
      '&language[enabled]=false';

    var controller =
      typeof AbortController !== 'undefined'
        ? new AbortController()
        : null;

    var timeoutId = window.setTimeout(function () {
      if (controller) {
        controller.abort();
      }
    }, 5000);

    try {
      var response = await fetch(suggestionUrl, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        signal: controller ? controller.signal : undefined
      });

      if (!response.ok) {
        return '';
      }

      var payload = await response.json();

      var detectedCountry =
        payload &&
        payload.detected_values &&
        payload.detected_values.country &&
        payload.detected_values.country.handle;

      return detectedCountry
        ? String(detectedCountry).toUpperCase()
        : '';
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  async function initializeMarketLocalization() {
    /*
     * Verify whether the previous switch actually succeeded.
     */
    var switchState = getSwitchState();

    if (
      switchState &&
      switchState.targetCountry === currentCountry
    ) {
      clearSwitchState();
    }

    try {
      var detectedCountry = await detectCountry();

      if (!detectedCountry) {
        return;
      }

      /*
       * Shopify can't switch to countries that aren't enabled in
       * localization.available_countries.
       */
      if (availableCountries.indexOf(detectedCountry) === -1) {
        clearSwitchState();
        return;
      }

      if (detectedCountry === currentCountry) {
        clearSwitchState();
        return;
      }

      if (!canAttemptSwitch(detectedCountry)) {
        console.warn(
          'Fullord Market localization: Shopify did not apply country ' +
          detectedCountry +
          ' after ' +
          maximumAttempts +
          ' attempts.'
        );

        return;
      }

      switchCountry(detectedCountry);
    } catch (error) {
      /*
       * Keep the current Shopify Market if GeoIP detection is unavailable.
       * This prevents a broken endpoint, VPN or network filter from
       * interrupting the storefront.
       */
      if (error && error.name !== 'AbortError') {
        console.warn(
          'Fullord Market localization could not detect the visitor country.',
          error
        );
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeMarketLocalization,
      { once: true }
    );
  } else {
    initializeMarketLocalization();
  }
})();